export default "__VITE_ASSET__DF0jyZ4q__"